import React, { useEffect, useState } from "react";
import * as Const from "./../_Const";
import { useFormCtx } from "./../FormContext";

const Button = ({ className, title, onClick, type = "next", place = "right", showIcon = true, canWrap = true }) => {
  const { isAnimationDisabled } = useFormCtx();
  const [fade, setFade] = useState(false);
  const [isReadOnly, setReadOnly] = useState(false);
  let icon = "";
  let colorClasses = "";
  const isTerminal = Const.isTerminal();
  const fadeClass = fade ? "fade" : "";
  let spanCss = "flex-auto";
  let canUseFade = !isAnimationDisabled && !isTerminal;
  const terminalClasses = isTerminal ? "active:bg-accent-dark active:text-accent-secondary" : "";

  function handleClick() {
    if (type === "clickonce") {
      setReadOnly(true);
    }

    if (canUseFade) {
      setFade(true);
    } else {
      setTimeout(() => onClick && onClick(), 250);
    }
  }

  function onAnimationEnd() {
    setFade(false);
    if (onClick) {
      console.log("onanimationend");

      onClick();
    }
  }

  if (type === "next") {
    colorClasses = "text-accent-dark bg-accent-secondary";
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="flex-none w-8 fill-accent-dark hover:fill-white active:fill-white"
        width="11.617"
        height="18"
        viewBox="0 0 11.617 18"
      >
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  } else if (type === "back") {
    colorClasses = "border border-secondary hover:border-accent-secondary text-secondary hover:text-accent-dark hover:bg-accent-secondary";
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9.035"
        height="14"
        viewBox="0 0 9.035 14"
        className="flex-none w-8 fill-secondary  group-hover:fill-accent-dark"
      >
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M10.468,14.49,4.52,20.438a1.045,1.045,0,0,1-1.483,0l-.988-.988a1.045,1.045,0,0,1,0-1.483l4.216-4.216L2.049,9.535a1.045,1.045,0,0,1,0-1.483l.984-1a1.045,1.045,0,0,1,1.483,0L10.463,13A1.047,1.047,0,0,1,10.468,14.49Z"
          transform="translate(10.776 20.746) rotate(180)"
        />
      </svg>
    );
  } else if (type === "error") {
    colorClasses = "text-white  bg-error";
  } else if (type === "navbar") {
    colorClasses = "text-accent-dark  bg-white";
  } else if (type === "error-dark") {
    colorClasses = "text-white  bg-error-dark";
  } else if (type === "clickonce") {
    colorClasses = isReadOnly ? "text-disabled bg-disabled-dark" : "text-accent-dark bg-accent-secondary";
  } else if (type === "primary") {
    colorClasses = "text-white bg-accent";
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="flex-none w-8 fill-white" width="11.617" height="18" viewBox="0 0 11.617 18">
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  } else if (type === "terminal") {
    colorClasses = "text-white bg-accent active:bg-accent-dark";
    spanCss = "";
    canUseFade = false;
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="flex-none w-8 fill-white" width="11.617" height="18" viewBox="0 0 11.617 18">
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  } else if (type === "terminal-error") {
    // colorClasses = "text-white bg-accent active:bg-accent-dark";
    colorClasses = "text-white active:text-white bg-error active:bg-error-dark";
    spanCss = "";
    canUseFade = false;
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" className="flex-none w-8 fill-white" width="11.617" height="18" viewBox="0 0 11.617 18">
        <path
          id="Icon_awesome-angle-right"
          data-name="Icon awesome-angle-right"
          d="M12.961,16.7,5.314,24.35a1.344,1.344,0,0,1-1.906,0L2.137,23.079a1.344,1.344,0,0,1,0-1.906l5.421-5.421L2.137,10.331a1.344,1.344,0,0,1,0-1.906L3.4,7.143a1.344,1.344,0,0,1,1.906,0l7.648,7.648A1.346,1.346,0,0,1,12.961,16.7Z"
          transform="translate(-1.74 -6.746)"
        />
      </svg>
    );
  }

  function replaceWithBr(text, canWrap) {
    if (canWrap && text) {
      return text.replace(/\n/g, "<br />");
    }
    return text;
  }

  return (
    <button
      onClick={handleClick}
      onAnimationEnd={onAnimationEnd}
      disabled={isReadOnly}
      className={
        "group min-h-12 px-4 py-2 place-content-center font-bold text-md flex items-center rounded-2xl uppercase shadow-md " +
        colorClasses +
        " " +
        className +
        " " +
        fadeClass +
        " " +
        terminalClasses
      }
    >
      {showIcon && place === "left" && icon}
      <span className={`mx-4 ${spanCss}`} dangerouslySetInnerHTML={{ __html: replaceWithBr(title, canWrap) }} />
      {showIcon && place === "right" && icon}
    </button>
  );
};

export default Button;
